<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">紐付設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <label class="caution-color">※設定は間違えないように慎重に行ってください。</label>
        <div class="group">
          <!-- ヘッダ -->
          <label></label>
          <label class="align-center">い</label>
          <label class="align-center">と</label>
          <label class="align-center">ぐ</label>
          <label class="align-center">ち</label>
          <label class="align-center">さ</label>
          <label class="align-center">とう</label>
          <label class="align-center">な</label>
          <label class="align-center">に</label>
          <label class="align-center">ク</label>
          <label>Ｐコード</label>
          <label>商品名</label>
          <label>規格名</label>

          <!-- 代表商品群 -->
          <label [style.margin-top.px]="3">代表</label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki0" #chk_Ibaraki0>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi0" #chk_Tochigi0>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma0" #chk_Gunma0>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba0" #chk_Chiba0>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama0" #chk_Saitama0>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo0" #chk_Tokyo0>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano0" #chk_Nagano0>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata0" #chk_Niigata0>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[0].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco0" #chk_Kuruco0>
          <input type="text" class="lbl-pcode" id="lbl_pCode0"
            #lbl_pCode0 value="{{kymw0500Model.relatedDataList[0].pCode}}">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName0" readonly
            #lbl_goodsName0 value="{{kymw0500Model.relatedDataList[0].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName0" readonly
            #lbl_standardName0 value="{{kymw0500Model.relatedDataList[0].guideStandardName}}">

          <!-- 空行 -->
          <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
          <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>

          <!-- 子商品群1行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki1" #chk_Ibaraki1>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi1" #chk_Tochigi1>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma1" #chk_Gunma1>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba1" #chk_Chiba1>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama1" #chk_Saitama1>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo1" #chk_Tokyo1>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano1" #chk_Nagano1>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata1" #chk_Niigata1>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco1" #chk_Kuruco1>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[1].pCode" [maxLength]="8" id="txti_pCode1" #txti_pCode1
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name"  id="lbl_goodsName1" readonly
            #lbl_goodsName1 value="{{kymw0500Model.relatedDataList[1].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName1" readonly
            #lbl_standardName1 value="{{kymw0500Model.relatedDataList[1].guideStandardName}}">

          <!-- 子商品群2行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki2" #chk_Ibaraki2>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi2" #chk_Tochigi2>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma2" #chk_Gunma2>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba2" #chk_Chiba2>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama2" #chk_Saitama2>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo2" #chk_Tokyo2>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano2" #chk_Nagano2>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata2" #chk_Niigata2>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco2" #chk_Kuruco2>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[2].pCode" [maxLength]="8" id="txti_pCode2" #txti_pCode2
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName2" readonly
            #lbl_goodsName2 value="{{kymw0500Model.relatedDataList[2].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName2" readonly
            #lbl_standardName2 value="{{kymw0500Model.relatedDataList[2].guideStandardName}}">

          <!-- 子商品群3行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki3" #chk_Ibaraki3>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi3" #chk_Tochigi3>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma3" #chk_Gunma3>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba3" #chk_Chiba3>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama3" #chk_Saitama3>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo3" #chk_Tokyo3>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano3" #chk_Nagano3>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata3" #chk_Niigata3>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco3" #chk_Kuruco3>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[3].pCode" [maxLength]="8" id="txti_pCode3" #txti_pCode3
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName3" readonly
            #lbl_goodsName3 value="{{kymw0500Model.relatedDataList[3].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName3" readonly
            #lbl_standardName3 value="{{kymw0500Model.relatedDataList[3].guideStandardName}}">

          <!-- 子商品群4行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki4" #chk_Ibaraki4>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi4" #chk_Tochigi4>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma4" #chk_Gunma4>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba4" #chk_Chiba4>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama4" #chk_Saitama4>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo4" #chk_Tokyo4>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano4" #chk_Nagano4>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata4" #chk_Niigata4>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco4" #chk_Kuruco4>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[4].pCode" [maxLength]="8" id="txti_pCode4" #txti_pCode4
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName4" readonly
            #lbl_goodsName4 value="{{kymw0500Model.relatedDataList[4].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName4" readonly
            #lbl_standardName4 value="{{kymw0500Model.relatedDataList[4].guideStandardName}}">

          <!-- 子商品群5行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki5" #chk_Ibaraki5>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi5" #chk_Tochigi5>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma5" #chk_Gunma5>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba5" #chk_Chiba5>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama5" #chk_Saitama5>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo5" #chk_Tokyo5>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano5" #chk_Nagano5>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata5" #chk_Niigata5>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco5" #chk_Kuruco5>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[5].pCode" [maxLength]="8" id="txti_pCode5" #txti_pCode5
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName5" readonly
            #lbl_goodsName5 value="{{kymw0500Model.relatedDataList[5].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName5" readonly
            #lbl_standardName5 value="{{kymw0500Model.relatedDataList[5].guideStandardName}}">

          <!-- 子商品群6行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki6" #chk_Ibaraki6>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi6" #chk_Tochigi6>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma6" #chk_Gunma6>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba6" #chk_Chiba6>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama6" #chk_Saitama6>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo6" #chk_Tokyo6>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano6" #chk_Nagano6>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata6" #chk_Niigata6>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco6" #chk_Kuruco6>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[6].pCode" [maxLength]="8" id="txti_pCode6" #txti_pCode6
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName6" readonly
            #lbl_goodsName6 value="{{kymw0500Model.relatedDataList[6].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName6" readonly
            #lbl_standardName6 value="{{kymw0500Model.relatedDataList[6].guideStandardName}}">

          <!-- 子商品群7行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki7" #chk_Ibaraki7>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi7" #chk_Tochigi7>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma7" #chk_Gunma7>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba7" #chk_Chiba7>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama7" #chk_Saitama7>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo7" #chk_Tokyo7>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano7" #chk_Nagano7>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata7" #chk_Niigata7>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco7" #chk_Kuruco7>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[7].pCode" [maxLength]="8" id="txti_pCode7" #txti_pCode7
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName7" readonly
            #lbl_goodsName7 value="{{kymw0500Model.relatedDataList[7].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName7" readonly
            #lbl_standardName7 value="{{kymw0500Model.relatedDataList[7].guideStandardName}}">

          <!-- 子商品群8行目 -->
          <label></label>
          <input type="checkbox" (change)="eventChkIbaraki_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedIB" [tabindex]="0" forcedEnabledMode=""
            id="chk_Ibaraki8" #chk_Ibaraki8>
          <input type="checkbox" (change)="eventChkTochigi_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedTO" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tochigi8" #chk_Tochigi8>
          <input type="checkbox" (change)="eventChkGunma_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedGU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Gunma8" #chk_Gunma8>
          <input type="checkbox" (change)="eventChkChiba_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedTI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Chiba8" #chk_Chiba8>
          <input type="checkbox" (change)="eventChkSaitama_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedSA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Saitama8" #chk_Saitama8>
          <input type="checkbox" (change)="eventChkTokyo_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedTK" [tabindex]="0" forcedEnabledMode=""
            id="chk_Tokyo8" #chk_Tokyo8>
          <input type="checkbox" (change)="eventChkNagano_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedNA" [tabindex]="0" forcedEnabledMode=""
            id="chk_Nagano8" #chk_Nagano8>
          <input type="checkbox" (change)="eventChkNiigata_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedNI" [tabindex]="0" forcedEnabledMode=""
            id="chk_Niigata8" #chk_Niigata8>
          <input type="checkbox" (change)="eventChkKuruco_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].selectedKU" [tabindex]="0" forcedEnabledMode=""
            id="chk_Kuruco8" #chk_Kuruco8>
          <input type="text" class="text-pcode" (input)="eventTxtPCode_CHANGEHandler($event)"
            [(ngModel)]="kymw0500Model.relatedDataList[8].pCode" [maxLength]="8" id="txti_pCode8" #txti_pCode8
            forcedEnabledMode="" plessInputTextSub [restrict]="'[P0-9]'">
          <input type="text" class="lbl-guide-goods-name" id="lbl_goodsName8" readonly
            #lbl_goodsName8 value="{{kymw0500Model.relatedDataList[8].guideGoodsName}}">
          <input type="text" class="lbl-guide-standard-name" id="lbl_standardName8" readonly
            #lbl_standardName8 value="{{kymw0500Model.relatedDataList[8].guideStandardName}}">
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Return" class="btn-secondary" [tabindex]="0" forcedEnabledMode=""
            (click)="eventBtnReturn_CLICKHandler(null)" #btn_Return>初期状態</button>
          <button id="btn_Update" class="btn-primary" [tabindex]="0" forcedEnabledMode=""
            (click)="eventBtnUpdate_CLICKHandler()" #btn_Update>設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventBtnClose_CLICKHandler()" #btn_Close></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>